import React, { memo } from 'react';

import { IncidentType } from 'views/components/UI/IncidentType/IncidentType';
import { setIncidentsTypes } from 'consts/adas';

interface IIncidentTypeWrap {
  type: number;
  ellipsedText?: boolean;
  smallIcon?: boolean;
  noIcon?: boolean;
}

export const IncidentTypeWrap: React.FC<IIncidentTypeWrap> = memo(({type, smallIcon, ellipsedText, noIcon}) => {
  const incident = setIncidentsTypes()[type];
  const color = incident?.color || '#CDCDCD';
  const name = incident?.shortName || incident?.name || `Событие ИСПВ ${type || ''}`;

  return (
    <IncidentType
      width={'auto'}
      name={name}
      color={color}
      ellipsedText={ellipsedText}
      smallIcon={smallIcon}
      noIcon={noIcon}
    />
  )
});